import classNames from 'classnames';

// Shared by Card.tsx and CardShell.tsx so the two "card" surface implementations (CardLoader-wrapped
// vs a plain forwardRef div) can't drift apart on their visual base styling.
export const cardClassName = (withPadding: boolean, className?: string): string =>
  classNames('card', 'rounded-none', 'lg:rounded', { 'p-4': withPadding }, className);
